// service/api/ReportsService.js
import axios from 'axios';

export const ReportFormat = {
  Pdf: 'Pdf',
  Excel: 'Excel'
};

class ReportsService {
  constructor() {
    this.api = axios.create({
      baseURL: import.meta.env.VITE_API_BASE_URL
    });
  }

  // Générer un rapport pour un titre spécifique ou tous les titres
  async generateHoldersReport(request) {
    const params = new URLSearchParams();
    
    params.append('format', request.format);
    
    if (request.securityId) params.append('securityId', request.securityId.toString());
    if (request.securityName) params.append('securityName', request.securityName);
    if (request.accountName) params.append('accountName', request.accountName);
    if (request.accountCompanyName) params.append('accountCompanyName', request.accountCompanyName);

    const response = await this.api.post(
      `/api/Security/generate-holders-report/${request.domainId}`,
      null,
      {
        params,
        responseType: 'blob'
      }
    );

    this.downloadFile(response, request.format);
  }

  // Télécharger le fichier généré
  downloadFile(response, format) {
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const contentDisposition = response.headers['content-disposition'];
    
    let fileName = `rapport_detenteurs_${new Date().getTime()}`;
    
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (fileNameMatch && fileNameMatch.length === 2) {
        fileName = fileNameMatch[1];
      }
    } else {
      // Nom par défaut basé sur le format
      const extension = format === ReportFormat.Pdf ? '.pdf' : '.xlsx';
      fileName += extension;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  // Obtenir les formats disponibles
  async getAvailableFormats() {
    const response = await this.api.get('/api/Security/formats');
    return response.data;
  }
}

export const reportsService = new ReportsService();